export default __webpack_public_path__ + "static/media/loading.ec0948d8.jpg";